import React from 'react';
import DataTableWrapper from '../DataTableWrapper';

const OthersDataTable = ({ records, loading, currentPage, setCurrentPage, totalCount, totalPages, rowsPerPage }) => {
    return (
        <DataTableWrapper
            loading={loading} currentPage={currentPage} setCurrentPage={setCurrentPage}
            totalCount={totalCount} totalPages={totalPages} rowsPerPage={rowsPerPage}
        >
            <table className="table table-striped table-hover table-bordered align-middle text-center mb-0" style={{ fontSize: 13 }}>
                        <thead>
                            <tr>
                                <th rowSpan={3}>Sr. No.</th>
                                <th rowSpan={3}>Report Date</th>
                                <th rowSpan={3}>District Name</th>
                                <th rowSpan={3} className="section-divider">State Name</th>

                                <th colSpan={4} className="cohort-header-children section-divider">Low Birth Wt (0-6 M)</th>
                                <th colSpan={4} className="cohort-header-children section-divider">Children (6-59 M)</th>
                                <th colSpan={4} className="cohort-header-child section-divider">Child (5-9 Y)</th>
                                <th colSpan={4} className="cohort-header-adolescents section-divider">Adolescents (10-19 Y)</th>
                                <th colSpan={4} className="cohort-header-preg section-divider">Pregnant Women</th>
                                <th colSpan={4} className="cohort-header-lactating section-divider">Lactating mothers</th>
                                <th colSpan={4} className="cohort-header-wra">WRA (20-49 Y)</th>
                            </tr>
                            <tr>
                                {/* Low Birth Weight (0-6 M) */}
                                <th className="cohort-children">Non Anaemic</th>
                                <th className="cohort-children">Mild</th>
                                <th className="cohort-children">Moderate</th>
                                <th className="cohort-children section-divider">Severe</th>

                                {/* Children (6-59 M) */}
                                <th className="cohort-children">Non Anaemic</th>
                                <th className="cohort-children">Mild</th>
                                <th className="cohort-children">Moderate</th>
                                <th className="cohort-children section-divider">Severe</th>

                                {/* Child (5-9 Y) */}
                                <th className="cohort-child">Non Anaemic</th>
                                <th className="cohort-child">Mild</th>
                                <th className="cohort-child">Moderate</th>
                                <th className="cohort-child section-divider">Severe</th>

                                {/* Adolescents (10-19 Y) */}
                                <th className="cohort-adolescents">Non Anaemic</th>
                                <th className="cohort-adolescents">Mild</th>
                                <th className="cohort-adolescents">Moderate</th>
                                <th className="cohort-adolescents section-divider">Severe</th>

                                {/* Pregnant Women */}
                                <th className="cohort-preg">Non Anaemic</th>
                                <th className="cohort-preg">Mild</th>
                                <th className="cohort-preg">Moderate</th>
                                <th className="cohort-preg section-divider">Severe</th>

                                {/* Lactating Mother */}
                                <th className="cohort-lactating">Non Anaemic</th>
                                <th className="cohort-lactating">Mild</th>
                                <th className="cohort-lactating">Moderate</th>
                                <th className="cohort-lactating section-divider">Severe</th>

                                {/* WRA (20-49 Y) */}
                                <th className="cohort-wra">Non Anaemic</th>
                                <th className="cohort-wra">Mild</th>
                                <th className="cohort-wra">Moderate</th>
                                <th className="cohort-wra">Severe</th>
                            </tr>
                            <tr className="text-center align-middle sub-header-ranges">
                                {[...Array(7)].map((_, i) => {
                                    const classes = [
                                        "cohort-children", "cohort-children", "cohort-child", "cohort-adolescents",
                                        "cohort-preg", "cohort-lactating", "cohort-wra"
                                    ];
                                    const baseClass = classes[i];
                                    return (
                                        <React.Fragment key={i}>
                                            <th className={baseClass} style={{ fontSize: 10 }}>&gt; 11 g/dl</th>
                                            <th className={baseClass} style={{ fontSize: 10 }}>10–10.9 g/dl</th>
                                            <th className={baseClass} style={{ fontSize: 10 }}>7-9.9 g/dl</th>
                                            <th className={`${baseClass} section-divider`} style={{ fontSize: 10 }}>&lt; 7 g/dl</th>
                                        </React.Fragment>
                                    );
                                })}
                            </tr>
                        </thead>
                        <tbody>
                            {records && records.length > 0 ? records.map((r, idx) => (
                                <tr key={r.id || idx}>
                                    <td>{(currentPage - 1) * rowsPerPage + idx + 1}</td>
                                    <td>{r.report_date}</td>
                                    <td><strong className="text-body">{r.district_name}</strong></td>
                                    <td className="section-divider">{r.state_name}</td>

                                    <td className="cohort-children">{r.lbw_non}</td>
                                    <td className="cohort-children">{r.lbw_mild}</td>
                                    <td className="cohort-children">{r.lbw_mod}</td>
                                    <td className="cohort-children color-severe section-divider">{r.lbw_sev}</td>

                                    <td className="cohort-children">{r.child_6_59m_non}</td>
                                    <td className="cohort-children">{r.child_6_59m_mild}</td>
                                    <td className="cohort-children">{r.child_6_59m_mod}</td>
                                    <td className="cohort-children color-severe section-divider">{r.child_6_59m_sev}</td>

                                    <td className="cohort-child">{r.child_5_9y_non}</td>
                                    <td className="cohort-child">{r.child_5_9y_mild}</td>
                                    <td className="cohort-child">{r.child_5_9y_mod}</td>
                                    <td className="cohort-child color-severe section-divider">{r.child_5_9y_sev}</td>

                                    <td className="cohort-adolescents">{r.adol_10_19y_non}</td>
                                    <td className="cohort-adolescents">{r.adol_10_19y_mild}</td>
                                    <td className="cohort-adolescents">{r.adol_10_19y_mod}</td>
                                    <td className="cohort-adolescents color-severe section-divider">{r.adol_10_19y_sev}</td>

                                    <td className="cohort-preg">{r.preg_non}</td>
                                    <td className="cohort-preg">{r.preg_mild}</td>
                                    <td className="cohort-preg">{r.preg_mod}</td>
                                    <td className="cohort-preg color-severe section-divider">{r.preg_sev}</td>

                                    <td className="cohort-lactating">{r.lact_non}</td>
                                    <td className="cohort-lactating">{r.lact_mild}</td>
                                    <td className="cohort-lactating">{r.lact_mod}</td>
                                    <td className="cohort-lactating color-severe section-divider">{r.lact_sev}</td>

                                    <td className="cohort-wra">{r.wra_non}</td>
                                    <td className="cohort-wra">{r.wra_mild}</td>
                                    <td className="cohort-wra">{r.wra_mod}</td>
                                    <td className="cohort-wra color-severe">{r.wra_sev}</td>
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan={32} className="text-center py-4 text-muted">
                                        No data available for OTHERS section.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
        </DataTableWrapper>
    );
};

export default OthersDataTable;
